import { render, staticRenderFns } from "./Clamp.vue?vue&type=template&id=fc093e72&lang=pug&"
import script from "./Clamp.vue?vue&type=script&lang=js&"
export * from "./Clamp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports